import { handleActions, combineActions } from 'redux-actions'
import { Map } from 'immutable'
import * as actions from './actions'

export const org = handleActions(
  {
    [combineActions(actions.fetchOrgStarted, actions.fetchOrgFailed, actions.receiveOrg)]: (state, action) =>
      state.setIn(['status', 'fetch'], action.type),

    [combineActions(actions.updateOrgStarted, actions.updateOrgFailed, actions.receiveOrg)]: (state, action) =>
      state.setIn(['status', 'update'], action.type),

    [combineActions(actions.createOrgStarted, actions.createOrgFailed, actions.receiveOrg)]: (state, action) =>
      state.setIn(['status', 'create'], action.type),

    [actions.fetchEndUserCountSuccess]: (state, action) => {
      return state.set('endUserCount', action.payload)
    },

    [actions.receiveOrg]: (state, action) => {
      return state.set('data', action.payload)
    },

    [actions.receiveOrgProperties]: (state, action) => {
      return state.setIn(['data', 'properties'], action.payload)
    },

    [actions.receiveOrgCutover]: (state, action) => {
      return state.setIn([action.meta], action.payload)
    },

    [actions.hasLimitedContactsMktEmailSuccess]: (state, action) => {
      return state.setIn(['hasLimitedContactsMktEmail'], action.payload['HAS_LIMITED_CONTACTS_MKTING_EMAIL'])
    },
  },
  Map()
)

export const orgUI = handleActions(
  {
    [actions.setOrgHandleUI]: (state, action) => {
      const { handle } = action.payload
      return state.setIn(['data', 'handle'], handle)
    },

    [actions.receiveOrgHandleExistence]: (state, action) => {
      return state.setIn(['valid', 'handle'], action.payload.valid)
    },
  },
  Map()
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/org/reducers.js